import { render, staticRenderFns } from "./AlarmForm.vue?vue&type=template&id=f15c62d6&scoped=true&"
import script from "./AlarmForm.vue?vue&type=script&lang=js&"
export * from "./AlarmForm.vue?vue&type=script&lang=js&"
import style0 from "./AlarmForm.vue?vue&type=style&index=0&id=f15c62d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15c62d6",
  null
  
)

export default component.exports